import React from "react";
import B2BAdminDashboard from "../components/B2B/B2BAdmin/B2BAdminDashboard/B2BAdminDashboard";
import B2BProtectedRoute from "../components/B2B/B2BShared/B2BProtectedRoute/B2BProtectedRoute";
import B2BToGcbRedirect from "./B2BToGcbRedirect";
// Cultural Events Admin Routes
import { AdminLogin } from "../components/CulturalEvents/Admin/AdminLogin";
import { AdminDashboard } from "../components/CulturalEvents/Admin/AdminDashboard";
import { AdminUpload } from "../components/CulturalEvents/Admin/AdminUpload";
import { ProtectedRoute } from "../components/CulturalEvents/Admin/ProtectedRoute";

/**
 * Admin routes configuration
 * Routes for B2B admin dashboard and Cultural Events admin
 */
export const adminRoutes = [
  // B2B Admin Routes
  {
    path: "/gcb/admin/dashboard",
    element: (
      <B2BProtectedRoute requireAdmin={true}>
        <B2BAdminDashboard />
      </B2BProtectedRoute>
    ),
    protected: true,
    adminOnly: true,
  },
  {
    path: "/b2b/admin/dashboard",
    element: <B2BToGcbRedirect />,
    protected: true,
    adminOnly: true,
  },
  // Cultural Events Admin Routes
  {
    path: "/admin/cultural-events/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/cultural-events/dashboard",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/cultural-events/upload",
    element: (
      <ProtectedRoute>
        <AdminUpload />
      </ProtectedRoute>
    ),
  },
];

